// extracted by mini-css-extract-plugin
export var chip = "_5d-0";
export var filterDropdown = "_5d-5";
export var filterItem = "_5d-6";
export var icon = "_5d-1";
export var removeButton = "_5d-3";
export var removeIcon = "_5d-4";
export var separator = "_5d-2";